module.exports = __webpack_public_path__ + "img/img8.92ff9df1.svg";